import { useEffect } from "react";
import { useLocation } from "react-router-dom";

function ScrollRestoration() {
  const { pathname } = useLocation();

  useEffect(() => {
    document.documentElement.scrollTop = 0;
    document.body.scrollTop = 0;
  }, [pathname]);

  return null;
}

export default ScrollRestoration;